import React from "react";
export default function Icon(props) {
  return (
    <svg
      width="12"
      height="14"
      viewBox="0 0 12 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.666748 9.13626L0.666748 11.595C0.666748 11.9676 0.807224 12.325 1.05727 12.5885C1.30732 12.852 1.64646 13 2.00008 13H10.0001C10.3537 13 10.6928 12.852 10.9429 12.5885C11.1929 12.325 11.3334 11.9676 11.3334 11.595V9.13626M6.00082 1V8.96164M6.00082 8.96164L9.04844 5.91953M6.00082 8.96164L2.95321 5.91953"
        stroke="#13816F"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}
